import { Button, CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import en from '../../../lang/en-us';
import { getKycNewStatus, getPaymentStatus } from '../../../redux-store/actions/newPurchase';
import { CommercialRootPath } from '../commercial/routeConfig';
import { $wait } from '../commercial/utils';

const { dbCommercial } = en

type Props = {};

type KycResponse = {
    isin: String;
    amcCode: String;
    status: string;
    statusCode: string;
}

function isErrorCode(code: (string | number)) {
    console.log('code = ' + code)
    return (code >= 400 && code <= 500) || (code == null || Number.isNaN(code))
}

const KycStatus: React.FunctionComponent<Props> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    let [paymentStatus, setPaymentStatus] = useState<KycResponse | null>(null);
    const [loading, setLoading] = useState(true)
    // const [kycResponse,setKycResponse] = useState<KycResponse>({isin:'',amc:''})

    let paymentType = 'KYC'

    // const isKycStatus =  history.location.pathname.includes('kyc-status')
    const isin = paymentStatus?.isin
    const amcCode = paymentStatus?.amcCode

    const statusCode = Number(paymentStatus?.statusCode)
    const isError = isErrorCode(statusCode)
    const paymentFailed = [13, 500].includes(statusCode) || isError
    const paymentSuccess = [14].includes(statusCode);
    const paymentPending = [0].includes(statusCode);


    useEffect(() => {
        if (!id) {
            history.push('/');
        }
        async function getStatus() {
            try {
                setLoading(true)
                const response: any = await dispatch(getKycNewStatus({ reqId: id }));
                await $wait(1500)
                const { body } = response || {};
                setPaymentStatus(body);
                console.log('kyc status = ', body)
            } catch (err: any) {
                alert(err.message);
                if (err.name == 422) {
                    history.push('/');
                }
            } finally {
                setLoading(false)
            }
        }
        getStatus();
    }, []);

    if (!id) {
        return null
    }

    const errorMessage = `There was an error while checking the KYC status`

    // if (!id || !paymentStatus) return null;


    return (
        <div className="curved-bg mf-success">

            <div
                className={`curved-bg-content nct-success-screen ${paymentFailed ? 'nct-failed-screen' : ''
                    }`}
            >
                {
                    loading ? <div style={{ display: 'flex', justifyContent: 'center', padding: '42px 24px' }}>
                        <CircularProgress />
                    </div>
                        :
                        <div className="curved-bg-content-inner">
                            <div className="curved-bg-content-inner-top">
                                <img
                                    className="change-email-img"
                                    src={
                                        paymentFailed
                                            ? '/images/mf-failure-character.png'
                                            : '/images/mf-success-character.png'
                                    }
                                    alt="icon"
                                />
                                <h3 className="subheading">
                                    {paymentFailed
                                        ? dbCommercial.exploreMfs.failureScreen.heading
                                        : dbCommercial.exploreMfs.successScreen.heading}
                                </h3>
                                <p>
                                    {`${isError ? errorMessage : paymentStatus?.status} with Req Id: `}
                                    <span>{id}</span>
                                </p>
                            </div>

                            <div className="curved-bg-content-inner-bottom">
                                <Button
                                    className="customBtn"
                                    onClick={() =>
                                        // paymentSuccess
                                        //     ?
                                        //     history.replace(`${CommercialRootPath}/${isin}/invest?amc=${amcCode}`)
                                        //     :
                                        history.replace('/')
                                    }
                                >
                                    {/* {paymentSuccess ?
                                        'Continue with transaction'
                                        :
                                        'Okay'
                                    } */}
                                    Okay
                                </Button>
                            </div>
                        </div>
                }
            </div>
        </div>
    );
};
export default KycStatus;